import { ActionContext, ActionTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations, TargetsMutationTypes } from './mutations';
import ServerAPI, { handleError } from '@/services/serverAPI';
import { TargetsApiResponse } from './types';

type AugmentedAction = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>;

export enum TargetsActionTypes {
  GET_TARGETS_DATA = 'GET_TARGETS_DATA',
}

export type Actions = {
  [TargetsActionTypes.GET_TARGETS_DATA](
    { commit }: AugmentedAction,
    payload: undefined
  ): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [TargetsActionTypes.GET_TARGETS_DATA]({ commit }) {
    commit(TargetsMutationTypes.SET_LOADING, true);

    try {
      const res: TargetsApiResponse = await ServerAPI.get('/users/targets');
      commit(TargetsMutationTypes.SET_TARGETS_DATA, res);
    } catch (e) {
      handleError(e);
      commit(TargetsMutationTypes.SET_TARGETS_DATA, []);
    } finally {
      commit(TargetsMutationTypes.SET_LOADING, false);
    }
  },
};
